import { render, staticRenderFns } from "./BosContactFormModal.vue?vue&type=template&id=bb3ab9d6&scoped=true&"
import script from "./BosContactFormModal.vue?vue&type=script&lang=js&"
export * from "./BosContactFormModal.vue?vue&type=script&lang=js&"
import style0 from "./BosContactFormModal.vue?vue&type=style&index=0&id=bb3ab9d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3ab9d6",
  null
  
)

export default component.exports